import React from 'react';

import Icon from 'chameleon/ui-stack/ui/base/icon';
import TextWithTooltip from 'chameleon/ui-stack/ui/assessments/text-with-tooltip';

const AssignedIconWithTooltip = ({ target, disable, ...props }) => (
  <TextWithTooltip
    renderInBody
    target={target}
    tooltip="Assigned"
    ariaLabel="Assigned"
    disable={disable}
    toolTipElementProps={{ role: 'img' }}
  >
    <Icon
      accessibility={{ ariaHidden: 'true' }}
      id="assigned"
      {...props}
      hasAriaLabelledBy={false}
      noRole
    />
  </TextWithTooltip>
);

export default AssignedIconWithTooltip;
